import { Automations as AutomationsOld } from "../components/Marketing/Automations";

export function Automations() {
  return (
    <div className="flex h-full max-h-full w-full flex-col gap-y-4 p-4 lg:p-8">
      <AutomationsOld />
    </div>
  );
}
